import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import apiService from '../services/api';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        // Vérifier d'abord si l'accès admin a été accordé
        const accessGranted = sessionStorage.getItem('adminAccessGranted');
        if (!accessGranted) {
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }
        
        // Vérifier si l'utilisateur est connecté
        if (!apiService.isAuthenticated()) {
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }

        // Récupérer les credentials stockés
        const credentialsStr = localStorage.getItem('adminCredentials');
        if (!credentialsStr) {
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }

        // Vérifier les credentials avec l'API
        try {
          const credentials = JSON.parse(credentialsStr);
          const response = await apiService.login(credentials);
          
          if (response.success) {
            setIsAuthenticated(true);
          } else {
            // Credentials invalides, nettoyer le localStorage
            localStorage.removeItem('isAdminLoggedIn');
            localStorage.removeItem('adminCredentials');
            setIsAuthenticated(false);
          }
        } catch (error) {
          console.error('Erreur lors de la vérification des credentials:', error);
          localStorage.removeItem('isAdminLoggedIn');
          localStorage.removeItem('adminCredentials');
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Erreur lors de la vérification:', error);
        localStorage.removeItem('isAdminLoggedIn');
        localStorage.removeItem('adminCredentials');
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthentication();
  }, []);

  // Afficher un spinner pendant la vérification
  if (isLoading) {
    return (
      <div className="protected-route-loading">
        <div className="container">
          <div className="loading-message">
            <h2>Vérification de l'authentification...</h2>
          </div>
        </div>
      </div>
    );
  }

  // Si non authentifié, rediriger vers la page de connexion
  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  // Si authentifié, afficher le composant protégé
  return children;
};

export default ProtectedRoute;